import { Microphone, MicrophoneSlash } from "@phosphor-icons/react";

import { RecordAudioButton } from "features/voice-message/components";

import { Button } from "common/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import { useActiveConversationContext } from "../../../context/ActiveConversationContext";
import useSNConversation from "../../../hooks/useSNConversation";

interface RecordButtonProps {
  isRecording: boolean;
  setIsRecording: (isRecording: boolean) => void;
  size?: "xs" | "sm" | "md" | "lg";
  isDisabled?: boolean;
}

const buttonVariant = "ghost-black";

export default function RecordButton({
  isRecording,
  setIsRecording,
  size = "md",
  isDisabled = false,
}: RecordButtonProps) {
  const { activeConversation } = useActiveConversationContext();
  const { isSNConversation } = useSNConversation(activeConversation);

  if (isSNConversation) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size={size}
            intent="iconOnly"
            disabled
            variant={buttonVariant}
          >
            <Microphone />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          Voice messages aren't supported in Sales Navigator conversations
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <RecordAudioButton onRecord={() => setIsRecording(!isRecording)}>
      {({ disabled, onClick }) => (
        <Button
          size={size}
          intent="iconOnly"
          disabled={isDisabled || disabled}
          variant={isRecording ? "secondary-black" : buttonVariant}
          onClick={onClick}
        >
          {disabled ? <MicrophoneSlash /> : <Microphone />}
        </Button>
      )}
    </RecordAudioButton>
  );
}
